import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Import() {
    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Import, Distribution & Delivery: Indian Spices & Grains</h1>
                </div>
            </div>
            <div className="container my-5">
                <div className="row">
                    {/* Main Content Section */}
                    <div className="col-lg-8 vendor-main-content">
                        <img
                            src="images/import1.jpg"
                            alt="Emergency Fund Management"
                            className="img-fluid"
                        />
                        <p>In partnership with Rojan Canada, we provide bulk import, nationwide distribution, and fast delivery of premium Indian spices, grains, and staples.</p>
                        <h2 style={{ fontWeight: 'bold' }}>Clients Served</h2>
                        <p>
                            <ul>
                                <li><b>South Asian grocery stores</b> <br /><br /></li>
                                <li><b>Restaurants and caterers</b> <br /><br /></li>
                                <li><b>Food wholesalers and distributors</b> <br /><br /></li>
                                <li><b>Ethnic retailers and private-label brands</b> <br /><br /></li>

                            </ul>
                        </p>
                        <h2 style={{ fontWeight: 'bold' }}>Product Categories</h2>
                        <p>
                            <b>Spices : </b> turmeric, cumin, chili, garam masala, cardamom, and more <br /><br />
                            <b>Grains & Rice :</b> basmati, sona masoori, idli rice<br /><br />
                            <b>Pulses & Lentils :</b> toor dal, urad dal, masoor dal, chana dal, moong dal<br /><br />
                            <b>Flours & Staples :</b> whole wheat atta, besan, maida, rava, rice flour
                        </p>
                        <h2 style={{ fontWeight: 'bold' }}>Delivery Services</h2>
                        <p>
                            <ul>
                                <li><b>Flexible delivery schedules</b> <br /><br /></li>
                                <li><b>Temperature-controlled transport</b> <br /><br /></li>
                                <li><b>Bulk packaging and palletized shipping</b> <br /><br /></li>
                                <li><b>Full tracking and logistics support</b> <br /><br /></li>
                                <li><b>Same-week dispatch on stock items</b> <br /><br /></li>

                            </ul>
                        </p>
                    </div>

                    {/* Sidebar Section */}
                    <div className="col-lg-4 vendor-sidebar">
                        {/* Why Choose Us */}
                        <div className="vendor-section vendor-services">
                            <h3 style={{ fontWeight: 'bold' }}>Why Choose Us?</h3>
                            <ul>
                                <li><span class="arrow">➤</span>Reliability and consistency you can trust</li>
                                <li><span class="arrow">➤</span>Comprehensive end-to-end supply solutions</li>
                            </ul>
                        </div>

                        {/* Latest Posts */}
                        <div className="vendor-section vendor-latest-posts" style={{ marginBottom: '20px' }}>
                            <img
                                src="images/import2.jpg"
                                alt="Emergency Fund Management"
                                className="img-fluid"
                            />

                        </div>
                        {/* Contact Info */}
                        {/* <div className="vendor-section vendor-contact-info">
                            <h3 style={{fontWeight:'bold'}}>Contact Info</h3>
                            <p>
                                <span> <i class="fa-solid fa-location-dot fa-xl" style={{ color: '#b80404' }}></i> </span>&nbsp;&nbsp;
                                <span>934 McCowan Road, Toronto M1P 3H6</span></p>
                            <p><i class="fa-solid fa-headset fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;+1 (647) 716-1330</p>

                            <p> <i class="fa-solid fa-envelope fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;info@rojancanada.com</p>

                        </div> */}
                    </div>
                </div>
            </div >
        </>
    );
}
